import { FC } from 'react';

import { AppBar, Box, Toolbar } from '@material-ui/core';

import { TNavBarProps } from './types';

import { NavbarBrand } from './helpers';
import { NavBarStyles } from './styles';

export const NavBar: FC<TNavBarProps> = ({ NavBarBrandInfo }) => {
  const styles = NavBarStyles();

  return (
    <AppBar className={styles.root} elevation={0}>
      <Box display="flex" justifyContent="center" alignItems="center" flex="1">
        <Toolbar className={styles.toolbar} disableGutters>
          <NavbarBrand NavBarBrandInfo={NavBarBrandInfo} />
        </Toolbar>
      </Box>
    </AppBar>
  );
};
